var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @specification
 * Adds attribute 'aria-expanded=true' based on the property 'open' if the component has 'hasSubtree' property.
 */
var treeTitleBehavior = function (props) { return ({
    attributes: {
        root: __assign({}, (props.hasSubtree && { 'aria-expanded': props.open ? 'true' : 'false' })),
    },
}); };
export default treeTitleBehavior;
